module.exports = __webpack_public_path__ + "static/media/parawebcv_page-0014.7110e4df.jpg";